module.exports = __webpack_public_path__ + "static/media/undying.2aaaa59d.png";